import * as React from "react";
import {DocumentManager} from "./Manager/PDFManager/DocumentManager";
import {AnnotationManager} from "./Manager/PDFManager/AnnotationManager";
declare var pdfjsLib:any;
import 'shared/styles/bootstrap.css';
import {PDFPreview} from "./PDFPreview/PDFPreview";
import {PageManager} from "./Manager/PDFManager/PageManager";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {DocumentManagerOptions} from "./Manager/PDFManager/DocumentManager.Options";
import {SelectAPDF} from "./Controls/SelectAPDF";
import {CSSProperties} from "react";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {TemplateSettings} from "./Dialogs/TemplateSettings/TemplateSettings";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {faDraftingCompass} from "@fortawesome/free-solid-svg-icons/faDraftingCompass";
import {SettingTabs} from "./Tabs/SettingTabs/SettingTabs";
import {DesignerTab} from "./Tabs/DesignerTab/DesignerTab";
import {TopBar} from "./Controls/TopBar";
import {WelcomeDialog} from "./Dialogs/WelcomeDialog";
export class MainPage extends React.Component<MainPageProps, MainPageState> {
    static defaultProps: Partial<MainPageProps> = {};
    public SelectedAnnotation:AnnotationManager;
    public DocumentManager:DocumentManager;
    public MappingContainer:HTMLDivElement;
    constructor(props: MainPageProps) {
        super(props);
        this.state = {
            State:'vertical',
            Height:'auto',
            MainTab:'Designer'
        };
        this.DocumentManager=this.props.DocumentManager;
        this.PDFContainerRendered=this.PDFContainerRendered.bind(this);
        if(this.DocumentManager.Options.Id==0)
        {
            Dialog.Show(<WelcomeDialog DocumentManager={this.DocumentManager}/>)
        }
    }


    public render() {
        let mappingContainerStyles:CSSProperties={height:this.state.State=='vertical'?'auto':this.state.Height,marginTop:20};
        let mappingsStyles:CSSProperties={};
        let previewStyles:CSSProperties={};

        if(this.state.State=="twocolumns")
        {
            mappingContainerStyles.display='flex';
            mappingContainerStyles.marginTop=20;


            previewStyles.height='100%';
            previewStyles.width='calc(50% - 2px)';
            previewStyles.overflow='auto';

            mappingsStyles.height="100%";
            mappingsStyles.width='calc(50% - 2px)';
            mappingsStyles.overflowY='auto';


        }

        return (
            <div className={'rednao pdfdesigner'} style={{height:'100%'}}>
                <TopBar DocumentManager={this.DocumentManager}/>

                <div style={{height:'calc(100% - 70px)'}}>
                    <div style={{height:'37px',padding:0,margin:0,borderBottom:'1px solid #afafaf'}} className={'nav-tab-wrapper'}>
                        <a style={{cursor:'pointer',marginTop:1}} className={'nav-tab '+(this.state.MainTab=='Designer'?'nav-tab-active':'')} onClick={()=>this.setState({MainTab:'Designer'})}><FontAwesomeIcon icon={faDraftingCompass}/> Designer</a>
                    </div>
                    <div style={{height:'calc(100% - 37px)'}}>
                        {this.state.MainTab=='Designer'&&<DesignerTab DocumentManager={this.props.DocumentManager}/>}
                        {this.state.MainTab=='Settings'&&<SettingTabs DocumentManager={this.props.DocumentManager}/>}
                    </div>
                </div>

            </div>
        )
    }



    PDFContainerRendered(node:any)
    {
        this.DocumentManager.PDFContainer=node;
    }




}


interface MainPageProps {
    DocumentManager:DocumentManager;
}

interface MainPageState {
    State:'vertical'|'twocolumns';
    Height:any;
    MainTab:string;
}
declare let download;